var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnsIconFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    d: "M0 4.499h32V36.5H0V4.499z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "#E9E9E9",
    strokeWidth: 3,
    d: "M20.157 10.979h2.841V6.688c-.428-.058-2.263-.191-3.968-.191-3.565 0-6.334 2.237-6.334 6.346v3.429H9.002v4.639h3.694v12.592h5.151V20.911h4.015l.604-4.639h-4.619v-2.957c0-1.391.369-2.336 2.31-2.336z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsIconFace);
export default __webpack_public_path__ + "static/media/sns-icon-face.681128f9b1cacfe1246277fb38a4d5eb.svg";
export { ForwardRef as ReactComponent };